/**
 * Streaks, milestones, freezes, and daily challenges — everything the
 * `StreakDetailModal` shows.
 *
 * These strings were hardcoded English inside the gamification components,
 * which is why `npm run i18n:coverage` reported this whole surface as
 * untranslated: there was no key to translate, only copy pasted into JSX.
 */
export const gamification = {
  streak: {
    modalTitle: "Streak details",
    /** The dialog's headline. Zero gets its own line — see `none`. */
    days_one: "{{count}} day streak",
    days_other: "{{count}} day streak",
    /**
     * The unit on its own, for the display figure in the header where the
     * number is rendered as its own element. Never pass `count` here — it
     * would resolve the plural form and print the number twice.
     */
    dayWord: "day streak",
    none: "No active streak",
    longest: "Longest {{count}}",
    freezes_one: "{{count}} freeze",
    freezes_other: "{{count}} freezes",
    xpWord: "XP",
    sections: "Streak sections",
    activeDays_one: "{{count}} active day",
    activeDays_other: "{{count}} active days",
    previousMonth: "Previous month",
    nextMonth: "Next month",
    legendLess: "Less",
    legendMore: "More",
    legendFreeze: "Freeze",
    legendMilestone: "Milestone",
    daysToMilestone_one: "{{count}} day to {{badge}}",
    daysToMilestone_other: "{{count}} days to {{badge}}",
    next: "Next",
    loading: "Loading activity…",
    loadingMilestones: "Loading milestones…",
    loadingChallenges: "Loading challenges…",
    freezesTitle: "Streak freezes",
    freezesUsed: "{{count}} used so far",
    freezesAvailable: "{{count}} of {{max}} freezes available",
    freezeExplanation:
      "A freeze is spent automatically the day you miss, so the streak survives. Earn them from milestones.",
  },
  challenges: {
    title: "Daily challenges",
    empty: "Today's challenges are being set up. Check back shortly.",
    open: "Go to this challenge",
    minutesShort: "min",
    default: "Daily challenge",
    vocabulary_review: "Review Vocabulary",
    practice_topic: "Practice a Topic",
    create_topic: "Create a Topic",
    study_time: "Study Time",
    video_shadowing: "Video Shadowing",
    video_dictation: "Video Dictation",
  },
} as const;